import(/* webpackMode: "eager" */ "/data/jenkins-new/workspace/web-server/packages/core/components/Locale/LocaleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/jenkins-new/workspace/web-server/packages/web-ssr/src/components/PageLayout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/jenkins-new/workspace/web-server/packages/web-ssr/src/components/ResponsiveLayout/index.tsx");
